{
  "messages": {
    "networkError": "ネットワークエラーが発生しました。問題が解決しない場合は、お問い合わせください。",
    "appointmentUpdatedValidationFailed": "予約は更新されましたが、外部検証に失敗しました。",
    "appointmentCreatedValidationFailed": "予約は作成されましたが、外部検証に失敗しました。",
    "validationErrorDetail": "<br /> 検証エラー：{error}"
  },
  "titles": {
    "warehouseRuleFailed": "倉庫のルールを満たしていません",
    "validationServerError": "検証サーバーエラー",
    "appointmentUpdatedWithValidationError": "予約は更新されましたが、検証エラーがあります",
    "appointmentCreatedWithValidationError": "予約は作成されましたが、検証エラーがあります"
  }
}
